import { useLogin } from "../../api/useLoginApi";
import { Config } from "../../config";
import { useSearchParams } from "react-router-dom";

function parseSearch(search: string): any {
  if (search.length > 0 && search[0] === "?") search = search.substring(1);
  return search.split("&").reduce((acc, p) => {
    const parts = p.split("=");
    acc[parts[0]] = parts[1];
    return acc;
  }, {} as any);
}

export function useFetchTokenByAuthCode() {
  const api = useLogin();
  const [, setSearchParams] = useSearchParams();

  const fetchTokenAfterLogin = async () => {
    try {
      const params = parseSearch(window.location.search);
      if (!params.code && !params.session_state) {
        const redirect_uri = encodeURIComponent(
          window.location.protocol +
            "//" +
            window.location.host +
            "/auth-callback",
        );
        return [
          null,
          `${
            Config.KEYCLOAK_URL
          }&redirect_uri=${redirect_uri}&state=${encodeURIComponent(
            window.location.href,
          )}`,
        ];
      } else {
        const redirectUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          "/auth-callback";

        const result = await api.getTokenFromCode({
          code: params.code,
          redirect_uri: redirectUrl,
        });
        const emptyParams = new URLSearchParams();
        setSearchParams(emptyParams);
        return [result.access_token, null];
      }
    } catch (e) {
      return [null];
    }
  };

  return { fetchTokenAfterLogin };
}
